
<template>
	<div ref="landingPage" class="relative w-full h-[95vh] grid place-content-center">
		<div 
			class="absolute top-0 left-0 w-full h-full z-0"
		>
			<div class="relative w-full h-full overflow-hidden">
				<div
					class="absolute top-0 left-0 w-full h-full bg-cover bg-center z-0" 
					style="background-image: url('images/apartment/1.jpg');"
				></div>

				<div
					class="absolute top-0 left-0 w-full h-full crt z-10 opacity-50"
				></div>
			</div>
		</div>

		<div class="w-screen h-screen grid z-20">
			<div class="relative w-fit h-fit mt-auto mx-auto scale-[1.2] md:scale-[1]">
				<div
					class="absolute w-full h-full scale-x-[1.5] scale-y-[2.0] z-10 bg-contain bg-center bg-no-repeat"
					style="background-image: url('images/other/island.png');"
				></div>
				<span class="absolute font-display-2 font-medium text-white lowercase z-30 text-clamp-md top-0 left-0 -translate-y-1/4 drop-shadow-[1px_1px_1px_#000]">
					{{ $t('global.apartment') }}
				</span>
				<span class="relative font-display uppercase tracking-widest text-clamp-lg font-medium text-brown mx-auto mt-auto z-20">
					Palma
				</span>
				<span class="absolute font-display-2 font-medium text-white z-30 text-clamp-md bottom-0 right-0 translate-x-[25%] translate-y-[25%] drop-shadow-[1px_1px_1px_#000]">
					Njivice, {{ $t('welcomePage.islandKrk') }}
				</span>
			</div>

			<div class="flex flex-col justify-center items-center w-fit h-fit gap-2 m-auto">
				<div class="flex justify-center items-center gap-4 h-12 scale-[0.7] md:scale-[0.8] lg:scale[1]">
					<div class="flex justify-center items-center gap-2 h-full">
						<ProfileIcon :width="40" :height="40" color="white" />

						<span class=" text-white text-2xl font-display">
							{{ infoConfig.guests }} + {{ infoConfig.extraGuests }}
						</span>
					</div>
					<div class="h-full grid place-content-center px-4 border-l border-r border-white">
						<ParkingIcon :width="40" :height="40" color="white" />
					</div>
					<div class="h-full flex justify-center items-center gap-4">
						<BeachIcon :width="40" :height="40" color="white" />

						<span class=" text-white text-2xl font-display">
							70m
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ParkingIcon from './icons/ParkingIcon.vue';
import ProfileIcon from './icons/ProfileIcon.vue';
import BeachIcon from './icons/BeachIcon.vue';

import { infoConfig } from '@/assets/config/infoConfig';

export default {
	name: 'LandingPage',
	components: {
		ParkingIcon,
		ProfileIcon,
		BeachIcon,
	},
	setup() {
		return {
			infoConfig,
		};
	},
}
</script>

<style>
.crt::before {
	content: " ";
	display: block;
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	background: linear-gradient(rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.2) 50%), linear-gradient(90deg, rgba(255, 0, 0, 0.06), rgba(0, 255, 0, 0.02), rgba(0, 0, 255, 0.06));
	z-index: 2;
	background-size: 100% 2px, 3px 100%;
	pointer-events: none;
}
</style>
